import { forwardRef } from 'react';
import classNames from 'classnames';
import { Button } from 'react-bootstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import type { IconProp } from '@fortawesome/fontawesome-svg-core';
import type { ButtonProps } from 'react-bootstrap';
import type { ReactNode } from 'react';

interface IconButtonProps extends ButtonProps {
  icon?: IconProp;
  iconAlign?: 'left' | 'right' | 'middle';
  iconClassName?: string;
  transform?: string;
  children?: ReactNode;
}

const IconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (
    {
      icon,
      iconAlign = 'left',
      iconClassName,
      transform,
      children,
      ...rest
    },
    ref,
  ) => (
    <Button {...rest} ref={ref}>
      {iconAlign === 'right' && children}
      <FontAwesomeIcon
        icon={icon ?? 'circle'}
        className={classNames(iconClassName, {
          'me-1': children && iconAlign === 'left',
          'ms-1': children && iconAlign === 'right',
        })}
        transform={transform}
      />
      {iconAlign === 'left' || iconAlign === 'middle' ? children : false}
    </Button>
  ),
);

IconButton.displayName = 'IconButton';

export default IconButton;
